<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/payCenter/balance' }"
        >财务中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>余额管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户名称 :">
        <el-input
          size="small"
          v-model="formInline.merchantName"
          placeholder="请输入商户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="服务商 :">
        <el-input
          size="small"
          v-model="formInline.disCompanyName"
          placeholder="请输入服务商名称"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="30px">
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="onExport"
        >导出数据</el-button
      >
    </div>
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="distributeCompanyName"
        label="服务商"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.distributeCompanyName)">
            {{ scope.row.distributeCompanyName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="可用余额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invoiceAmount"
        label="可开票金额"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <div style="background-color: #fff; padding: 15px; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总可用余额：</span
              ><span>{{ formatNumber(currentPageSummary.totalBalance) }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总可开票金额：</span
              ><span>{{
                formatNumber(currentPageSummary.totalInvoiceAmount)
              }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <el-dialog
      :title="dialogExport.title"
      :visible.sync="dialogExport.isShowDialog"
      width="600px"
    >
      <div>
        <el-form
          ref="exportForm"
          :model="exportForm"
          size="default"
          label-width="90px"
        >
          <el-form-item label="">
            <el-checkbox-group v-model="exportForm.exportOptions">
              <el-checkbox label="all">全部</el-checkbox>
              <el-checkbox label="hasBalance">是否有余额</el-checkbox>
              <el-checkbox label="hasInvoiceAmount"
                >是否有未提交开票金额</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <template>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogExport.isShowDialog = false">取消</el-button>
          <el-button
            type="primary"
            :loading="dialogExport.isExporting"
            :disabled="dialogExport.isExporting"
            @click="exportdata"
            >确认导出</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import { merchantBalance } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏

      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        disCompanyName: "",
        merchantName: "",
      },

      userparm: [], //搜索权限
      listData: [], //用户数据com
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      dialogExport: {
        isExporting: false,
        isShowDialog: false,
        type: "",
        title: "导出选项",
        submitTxt: "",
        isEdit: "",
      },
      exportForm: {
        exportOptions: [],
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },
  computed: {
    currentPageSummary() {
      // 计算总和（处理 null/undefined 的情况）
      const summary = this.listData.reduce(
        (acc, item) => {
          acc.totalBalance += Number(item.balance) || 0;
          acc.totalInvoiceAmount += Number(item.invoiceAmount) || 0;
          return acc;
        },
        { totalBalance: 0, totalInvoiceAmount: 0 }
      );

      return summary;
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },

    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
      };
      this.getdata(this.formInline);
    },
    onExport() {
      this.dialogExport.isShowDialog = true;
      this.exportForm.exportOptions = [];
    },
    exportdata() {
      let params = {
        page: 1,
        pageSize: 99999999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        hasBalance: 0,
        hasInvoiceAmount: 0,
        isExport: 1,
      };

      // 根据选中的导出选项更新参数
      if (this.exportForm.exportOptions.includes("hasBalance")) {
        params.hasBalance = 1;
      }
      if (this.exportForm.exportOptions.includes("hasInvoiceAmount")) {
        params.hasInvoiceAmount = 1;
      }

      this.dialogExport.isShowDialog = true;
      this.dialogExport.isExporting = true;

      merchantBalance(params).then((res) => {
        if (res.msg == "success") {
          this.dialogExport.isShowDialog = false;
          this.dialogExport.isExporting = false;
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata(params) {
      this.loading = true;
      merchantBalance(params)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;

            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/payCenter/balance.vue